package com.shadowings.gero.presentation.model

import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.UserData

data class QuizUiState(
    val userData: UserData = UserData(),
    val quizList: List<IQuizContent> = emptyList(),
    val isTestMode: Boolean = false,
    val hideOptions: Boolean = false,
    val lessonId: String = ""
)

sealed interface QuizEffect {
    data class NavigateToPage(val index: Int) : QuizEffect
    data object NavigateBack : QuizEffect

    /**
     * XP the ViewModel has already persisted (e.g. onQuizCompleted's daily bonus). The screen
     * only feeds it to addExperienceAndCheckLevelUp without writing it again, so a level crossed
     * purely by that bonus still splices QuizLevelUpComposable into the pager. The write itself
     * can't depend on this effect: in correction mode the screen may pop before collecting it.
     */
    data class ExperienceGranted(val amount: Int) : QuizEffect
}
